import { useEffect } from 'react';

// ===================== ช่องค้นหา / ตัวกรอง มีสีพื้น + กำลังกรอง = เหลือง ทุกหน้า (ผู้ใช้ OK ตัวอย่าง 26/10/2569 · แบบเดียวกับ Portal FilterHighlight.js) =====================
//  - dropdown ตัวกรอง (ตัวเลือกแรก "ทั้งหมด / ทุก…" หรือมี data-filter-default) → ม่วงอ่อน · เลือกอย่างอื่นอยู่ = เหลือง
//  - ช่องพิมพ์ค้นหา (placeholder ขึ้นต้น 🔎 / มีคำว่า ค้นหา / type=search) → เขียวอ่อน · มีคำค้น = เหลือง
//  - ช่องวันที่ในแถวตัวกรองเดียวกัน มีวันที่ = เหลือง
// สีอยู่ใน shell.css ([data-hx-filter] [data-hx-sbox] [data-hx-filtered])
const ALL_RE = /ทั้งหมด|^\W*ทุก|ทั้งปี|^\W*all\W*$/i;
const isFilterSelect = (s) => s.hasAttribute('data-filter-default') || (s.options.length > 1 && ALL_RE.test(s.options[0].text || ''));
const selectOn = (s) => (s.hasAttribute('data-filter-default') ? s.value !== s.getAttribute('data-filter-default') : s.selectedIndex > 0);
const isSearch = (i) => i.type === 'search' || /^\s*🔎|ค้นหา/.test(i.placeholder || '') || /ค้นหา/.test(i.getAttribute('aria-label') || '');
const inFilterRow = (el) => {
  if (el.closest('[role=dialog]')) return false;
  let p = el.parentElement;
  for (let i = 0; p && i < 4; i += 1, p = p.parentElement) {
    if (p.querySelector('input[data-hx-sbox]') || [...p.querySelectorAll('select')].some(isFilterSelect)) return true;
  }
  return false;
};
const flag = (el, name, on) => { if (on) { if (!el.hasAttribute(name)) el.setAttribute(name, ''); } else if (el.hasAttribute(name)) el.removeAttribute(name); };

function scan() {
  document.querySelectorAll('.hx-content select, [role=dialog] select').forEach((s) => { const f = isFilterSelect(s); flag(s, 'data-hx-filter', f); flag(s, 'data-hx-filtered', f && selectOn(s)); });
  document.querySelectorAll('.hx-content input:not([type=checkbox]):not([type=radio]):not([type=date]), [role=dialog] input:not([type=checkbox]):not([type=radio]):not([type=date])').forEach((i) => {
    const f = isSearch(i); flag(i, 'data-hx-sbox', f); if (f) flag(i, 'data-hx-filtered', !!i.value); });
  document.querySelectorAll('.hx-content input[type=date]').forEach((i) => flag(i, 'data-hx-filtered', !!i.value && inFilterRow(i)));
}

export default function FilterHighlight() {
  useEffect(() => {
    // ค่าในช่องเปลี่ยนได้ทั้งจากผู้ใช้ และจากปุ่ม "ล้าง" ของหน้า (ไม่มี event) → ตรวจตอนพิมพ์/เลือก + ตรวจซ้ำเบา ๆ ทุก 0.5 วินาที
    const run = () => { try { scan(); } catch (e) { /* หน้ากำลังเปลี่ยน — รอบหน้า */ } };
    const t = setInterval(run, 500);
    document.addEventListener('change', run, true); document.addEventListener('input', run, true);
    run();
    return () => { clearInterval(t); document.removeEventListener('change', run, true); document.removeEventListener('input', run, true); };
  }, []);
  return null;
}
